module.exports = __webpack_public_path__ + "static/img/content.b01010c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/content.png
// module id = T8UY
// module chunks = 1